var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{attrs:{"two-line":"","dense":""}},_vm._l((_vm.photoPermissions),function(photoPermission,index){return _c('ClientPhotoPermissionListItem',{key:index,attrs:{"client-permission":photoPermission}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }